export const whyWork = [
    {
        title: 'Maternity/Paternity Leave',
        desc: "We believe that parent leave is important and want to support the talented young women and men in the workplace with fair policies that enable them to thrive in their career while growing a family."
    },

    {
        title: 'Healthcare, Vision, and Dental Insurance',
        desc: "We want everyone to stay healthy and happy, at work at and home."
    },

    {
        title: '401K Matching',
        desc: "Your financial security is important to us."
    },

    {
        title: 'Remote and Flexible Hours',
        desc: "We care more about getting the right people at the company than where they are located or exactly when they are at their computer."
    },

    {
        title: 'Fun Work Environment',
        desc: "Weekly online trivia game, Stocked snack cabinet (for when we used to be in the office), Happy hours, team lunches and office shenanigans (again, back before we lived in a pandemic)"
    },

    {
        title: 'No Pre-Set Vacation Days',
        desc: "We treat our employees like adults who can manage their own vacation and time off needs. Of course, you do need to show up to work, but we’re not tracking your time off."
    },

    {
        title: 'Respecting Work/Life Balance',
        desc: "We know that your life isn’t your work, and we want to respect that. We work hard but respect your time off, your need to recharge, and your passions outside the workplace."
    },


]

export default whyWork;